import apiClient from '../../shared/api/client';

export interface PartnerClaimResponse {
  organization: { id: number; name: string; slug: string };
  membership_created: boolean;
  enrollment_ids: number[];
  skipped_packages: Array<{ package_id: number; reason: string }>;
}

export const partnerApi = {
  claim: async (slug: string): Promise<PartnerClaimResponse> => {
    const { data } = await apiClient.post(`/partners/${encodeURIComponent(slug)}/claim`);
    return data;
  },
};

export const PENDING_PARTNER_SLUG_KEY = 'pending_partner_slug';
